import { Component, OnInit } from '@angular/core';
import { ModalService } from 'src/app/shared/services/modal.service';

@Component({
  selector: 'app-rate-inquiry-confirmation-modal',
  templateUrl: './rate-inquiry-confirmation-modal.component.html',
  styleUrls: ['./rate-inquiry-confirmation-modal.component.scss']
})
export class RateInquiryConfirmationModalComponent implements OnInit {

  constructor(private modal: ModalService) { }

  ngOnInit() {
  }

  onCancel() {
    this.modal.close('S');
  }

  save(){
    this.modal.close('B');
  }

}
